import script from "./WebDesignPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WebDesignPage.vue?vue&type=script&setup=true&lang=js"

import "./WebDesignPage.vue?vue&type=style&index=0&id=0d35bf46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d35bf46"]])

export default __exports__